import { useQuery } from "react-query";

import useApiHelper from "../../services/useApiHelper";
import { IDefaultResponseWithData } from "../../models/system/DefaultResponse";
import { nurtureCampaignQueryKeys } from "./queryKeys";
import { INurtureCampaign } from "../../models/nurtureCampaign/NurtureCampaign";

export function useNurtureCampaigns(agencyId: string) {
  const { get } = useApiHelper();

  const nurtureCampaigns = useQuery({
    queryKey: nurtureCampaignQueryKeys.all(agencyId),
    queryFn: () =>
      get(
        `/marketing/${agencyId}/nurture`
      ) as unknown as IDefaultResponseWithData<INurtureCampaign[]>,
    refetchOnWindowFocus: false,
  });

  return {
    nurtureCampaigns,
  };
}
